import { SCALING } from "../../src/actions/scaling-presets";
import { SEC } from "../../src/time-utils";
const slow = {
  slug: "slow",
  name: "Slow",
  description: "Makes the target slow and sluggish",
  duration: { ticks: SEC(8) },
  tags: ["debuff", "curse"],
  statEffects: [
    {
      stat: "movespeed",
      direction: "loss",
      scalingFactors: SCALING.SHADOW
    },
    {
      stat: "attackspeed",
      direction: "loss",
      scalingFactors: SCALING.SHADOW
    }
  ]
};
export {
  slow
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vbGliL2NvbmRpdGlvbnMvc2xvdy50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHR5cGUgeyBDb25kaXRpb25EZWZpbml0aW9uIH0gZnJvbSAnLi4vLi4vc3JjL2FjdGlvbnMvdHlwZXMnO1xuaW1wb3J0IHsgU0NBTElORyB9IGZyb20gJy4uLy4uL3NyYy9hY3Rpb25zL3NjYWxpbmctcHJlc2V0cyc7XG5pbXBvcnQgeyBTRUMgfSBmcm9tICcuLi8uLi9zcmMvdGltZS11dGlscyc7XG5cbmV4cG9ydCBjb25zdCBzbG93OiBDb25kaXRpb25EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnc2xvdycsXG4gIG5hbWU6ICdTbG93JyxcbiAgZGVzY3JpcHRpb246ICdNYWtlcyB0aGUgdGFyZ2V0IHNsb3cgYW5kIHNsdWdnaXNoJyxcbiAgZHVyYXRpb246IHsgdGlja3M6IFNFQyg4KSB9LFxuICB0YWdzOiBbJ2RlYnVmZicsICdjdXJzZSddLFxuICBzdGF0RWZmZWN0czogW1xuICAgIHtcbiAgICAgIHN0YXQ6ICdtb3Zlc3BlZWQnLFxuICAgICAgZGlyZWN0aW9uOiAnbG9zcycsXG4gICAgICBzY2FsaW5nRmFjdG9yczogU0NBTElORy5TSEFET1csXG4gICAgfSxcbiAgICB7XG4gICAgICBzdGF0OiAnYXR0YWNrc3BlZWQnLFxuICAgICAgZGlyZWN0aW9uOiAnbG9zcycsXG4gICAgICBzY2FsaW5nRmFjdG9yczogU0NBTElORy5TSEFET1csXG4gICAgfSxcbiAgXSxcbn07XG4iXSwKICAibWFwcGluZ3MiOiAiQUFDQSxTQUFTLGVBQWU7QUFDeEIsU0FBUyxXQUFXO0FBRWIsTUFBTSxPQUE0QjtBQUFBLEVBQ3ZDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLFVBQVUsRUFBRSxPQUFPLElBQUksQ0FBQyxFQUFFO0FBQUEsRUFDMUIsTUFBTSxDQUFDLFVBQVUsT0FBTztBQUFBLEVBQ3hCLGFBQWE7QUFBQSxJQUNYO0FBQUEsTUFDRSxNQUFNO0FBQUEsTUFDTixXQUFXO0FBQUEsTUFDWCxnQkFBZ0IsUUFBUTtBQUFBLElBQzFCO0FBQUEsSUFDQTtBQUFBLE1BQ0UsTUFBTTtBQUFBLE1BQ04sV0FBVztBQUFBLE1BQ1gsZ0JBQWdCLFFBQVE7QUFBQSxJQUMxQjtBQUFBLEVBQ0Y7QUFDRjsiLAogICJuYW1lcyI6IFtdCn0K
